var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.native && _vm.model)?_c('SiteIndex',{attrs:{"model":_vm.model,"white-list":[]}}):((_vm.native === _vm.PageNameEnum.SHOP_CART) && _vm.model)?_c('site-shop-cart',{attrs:{"model":_vm.model}}):((_vm.native === _vm.PageNameEnum.COUPON) && _vm.model)?_c('site-coupon',{attrs:{"model":_vm.model}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }